import { getMockAddress } from "./utils/getEnv";

export const APPLICATION = {
  ID: process.env.REACT_APP_ID,
  NAME: `@${process.env.REACT_APP_ID.replace("-", "_").toUpperCase()}`,
  EXTERNAL: ["WEB_CRM", "WEB_PUBLIC"].includes(
    process.env.REACT_APP_JOB_TEMPLATE_TYPE
  ),
  get BFF_URL() {
    if (!window.env) {
      return getMockAddress();
    }
    return window.env.BFF_URL;
  },

  get ENV() {
    if (!window.env) return getMockAddress();
    return window.env.ENV;
  },

  get RECAPTCHA_KEY() {
    if (!window.env) {
      return "";
    }
    return window.env.RECAPTCHA_KEY;
  },
};

export const PAGE = {
  ROOT: () => "/",
  COOKIE_POLICY: () => "/cookies",
  PRIVACY_POLICY: () => "/privacidade"
};
